export const getHeatmapOption = (distData: any) => {
    if (!distData) return {};
    const hours = Array.from({ length: 24 }, (_, i) => i + 'h');
    const days = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
    const data = [];
    let maxVal = 0;
    for (let i = 0; i < 7; i++) {
        for (let j = 0; j < 24; j++) {
            const val = distData.heatmap[i][j] || 0;
            data.push([j, i, val]);
            if (val > maxVal) maxVal = val;
        }
    }

    maxVal = Math.max(maxVal, 10);

    return {
        title: {
            text: '订单热力图 (UTC)',
            textStyle: { fontSize: 14, fontWeight: 600, color: '#1f2937' },
            left: 'center'
        },
        tooltip: {
            position: 'top',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: '#e5e7eb',
            textStyle: { color: '#374151' },
            formatter: (params: any) => {
                return `${days[params.value[1]]} ${params.value[0]}:00<br/>订单量: <b>${params.value[2]}</b>`;
            }
        },
        grid: { height: '55%', top: '12%', left: '8%', right: '8%' },
        xAxis: {
            type: 'category',
            data: hours,
            splitArea: { show: true, areaStyle: { color: ['rgba(250,250,250,0.3)', 'rgba(255,255,255,0.3)'] } },
            axisLabel: { color: '#6b7280', fontSize: 10 },
            axisLine: { show: false }
        },
        yAxis: {
            type: 'category',
            data: days,
            splitArea: { show: true, areaStyle: { color: ['rgba(250,250,250,0.3)', 'rgba(255,255,255,0.3)'] } },
            axisLabel: { color: '#6b7280' },
            axisLine: { show: false }
        },
        visualMap: {
            min: 0,
            max: maxVal,
            calculable: true,
            orient: 'horizontal',
            left: 'center',
            bottom: '8%',
            itemWidth: 20,
            itemHeight: 140,
            textStyle: { color: '#6b7280' },
            inRange: {
                color: ['#e0f2fe', '#7dd3fc', '#38bdf8', '#0ea5e9', '#0284c7', '#0369a1']
            }
        },
        series: [{
            name: '订单量',
            type: 'heatmap',
            data: data,
            label: {
                show: true,
                color: '#374151',
                fontSize: 10,
                formatter: (params: any) => params.value[2] || ''
            },
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowColor: 'rgba(0, 0, 0, 0.3)'
                }
            }
        }]
    };
};
